import React, { useState } from 'react';
import styles from './styles.module.css';
import bellImg from 'assets/bell.svg';
import edit from 'assets/edit.svg';
import dateFunctions from 'helpers/dateFunction';
import daysFromNow from 'helpers/daysFromNow';
import { CalendarContainer } from 'components';
import { useOrderReminder } from 'hooks';
import { useHistory } from 'react-router-dom';

const OrdersReminder = ({ orderId, redirectFn, submitText }) => {
  const reminderOptions = [
    { name: '4weeks', daysFromNow: 4 * 7, displayText: '4 weeks' },
    { name: '8weeks', daysFromNow: 8 * 7, displayText: '8 weeks' },
    { name: '12weeks', daysFromNow: 12 * 7, displayText: '12 weeks' },
  ];

  const [showCalendar, setShowCalendar] = useState();
  const [isChecked, setIsChecked] = useState(true);
  const [reminderDate, setReminderDate] = useState(daysFromNow(reminderOptions[0].daysFromNow));
  const [, postOrderReminder] = useOrderReminder();

  const history = useHistory();

  const handleSubmit = async () => {
    if (isChecked) {
      try {
        await postOrderReminder({
          reminder_date: reminderDate.toISOString(),
          order_ref: orderId,
          //force email consent to always be true pending future work to add more preferences
          email_consent: true
        });
        redirectFn();
      } catch (e) {
        console.error(e);
        history.push(`/pharmacy/error`);
      }
    } else {
      redirectFn();
    }
  };

  return (
    <>
      {!showCalendar && (
        <div className={styles.reminder}>
          <div className={styles.reminderForm}>
            <img src={bellImg} alt="Bell" className={styles.bellIcon} />
            <label htmlFor="checkbox">
              <h2 className={styles.reminderHeader}>Add an order reminder</h2>
            </label>
            <div className={`coop-form__row ${styles.customRow}`}>
              <div className="coop-form__choice">
                <input
                  type="checkbox"
                  name="option"
                  id="checkbox"
                  value="2"
                  onChange={() => setIsChecked((state) => !state)}
                  checked={isChecked}
                  className={`coop-form__field coop-form__checkbox ${styles.customRow__input}`}
                />
                <label htmlFor="checkbox" className={`${styles.customRow__choice} coop-form__label`} />
              </div>
            </div>
          </div>
          <p>We’ll remind you when to re-order your medication via email</p>
          {isChecked && (
            <div className={styles.reminderContainer}>
              <p>{`We will remind you in ${dateFunctions.getWeeksBetweenDates(new Date(), reminderDate)} weeks:`}</p>
              <div
                className={styles.dateSelectionContainer}
                onClick={() => {
                  setShowCalendar((state) => !state);
                }}>
                <p>{dateFunctions.formatDateWithNthNumber(reminderDate)}</p>
                <img src={edit} alt="pencil icon to edit order reminder date" />
              </div>
              <div className={styles.reminderPreferenceContainer}>
                <div>
                  <p className={styles.preferenceText}>I agree to receive order reminders via email.</p>
                  <p className={styles.preferenceText}>This will be applied to all order reminders.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {showCalendar && (
        <div className={styles.reminder}>
          <CalendarContainer date={reminderDate} setDate={setReminderDate} setShow={setShowCalendar} quickDateOptions={reminderOptions} />
        </div>
      )}
      {!showCalendar && (
        <button
          className={`coop-btn coop-btn--primary ${styles.button}`}
          onClick={handleSubmit}
          disabled={isChecked && !reminderDate}>
          {submitText}
        </button>
      )}
    </>
  );
};

export default OrdersReminder;
